import {
  SET_FORM_DATA,
  SET_FORM_LOADING,
  SET_MANUFACTURER_ID,
  SET_VARIANT_ID,
  SET_OFFER_PRICE,
  SET_MRP,
  SET_VENDOR_PRICE,
  SET_SUBMIT_LOADING
} from './constants';

const initialState = {
  formData: {
    manufacturers: [],
    variants: []
  },
  loading: true,
  manufacturerId: 0,
  variantId: 0,
  offerPrice: 0,
  mrp: 0,
  vendorPrice: 0,
  submitLoading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM_DATA:
      return {
        ...state,
        formData: action.formData
      };

    case SET_FORM_LOADING:
      return {
        ...state,
        loading: action.loading
      };

    case SET_MANUFACTURER_ID:
      return {
        ...state,
        manufacturerId: action.manufacturerId
      };

    case SET_VARIANT_ID:
      return {
        ...state,
        variantId: action.variantId
      };

    case SET_MRP:
      return {
        ...state,
        mrp: action.mrp
      };
    case SET_OFFER_PRICE:
      return {
        ...state,
        offerPrice: action.offerPrice
      };
    case SET_VENDOR_PRICE:
      return {
        ...state,
        vendorPrice: action.vendorPrice
      };
    case SET_SUBMIT_LOADING:
      return {
        ...state,
        submitLoading: action.submitLoading
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Modules/CreateNewManufacturerVariant/reducer.js